import { ArrowUUpLeftIcon } from '@phosphor-icons/react'
import { Children } from 'react'

import { Alert } from '@/components/ui/alert'
import { BorderLoader } from '@/components/ui/loaders/border-loader'

import { Button } from '../button'
import { EmptyState } from '../empty-state'
import { Icon } from '../icon'
import * as S from './table.styled'
import { TableBodyProps } from './table.types'

export const TableBody = ({
  children,
  columnsAmount,
  emptyText,
  emptyDescription,
  loading,
  error,
  onClearFilters,
}: TableBodyProps) => {
  const hasChildren = Children.count(children) > 0
  const showLoader = loading
  const showError = !showLoader && error
  const showEmpty = !showLoader && !showError && !hasChildren
  const showChildren = !showLoader && !showError && hasChildren

  const clearFiltersButton = onClearFilters ? (
    <Button use="primary" onClick={onClearFilters}>
      <Icon icon={ArrowUUpLeftIcon} />
      Clear Filters
    </Button>
  ) : undefined

  return (
    <tbody>
      {showLoader && (
        <S.StateRow>
          <S.StateCell colSpan={columnsAmount}>
            <BorderLoader size="large" />
          </S.StateCell>
        </S.StateRow>
      )}
      {showError && (
        <S.StateRow>
          <S.StateCell colSpan={columnsAmount}>
            <S.ErrorWrapper>
              <Alert type="error" title={error.message} />
            </S.ErrorWrapper>
          </S.StateCell>
        </S.StateRow>
      )}
      {showEmpty && (
        <S.StateRow>
          <S.StateCell colSpan={columnsAmount}>
            <EmptyState
              title={emptyText}
              description={emptyDescription}
              actions={clearFiltersButton}
            />
          </S.StateCell>
        </S.StateRow>
      )}
      {showChildren && children}
    </tbody>
  )
}
